module.exports = new __parcel__URL__("machine_info_speed_up_button.80b1ed5d.png").toString();